import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { uniq, capitalize } from 'lodash';
import moment from 'moment';
import { Link } from 'react-router';
import { urls } from 'helpers/url';
import { cutQuantityString } from '../../../../../../../utils/lineItemUtils';
import { formatTime } from '../../../../../../../utils/dateUtils';
import S from 'styles/table.scss';
import reportStyle from 'styles.scss';
import ReleaseMerchandise from '../../../components/ReleaseMerchandise';

function uniqueValues(a, prop) {
  return uniq(a.map(i => i[prop])).join(', ');
}

const WarehouseSummaryTable = ({ report: { data } }) =>
  <table className={`${S.cardTable} ${reportStyle.table}`} cellSpacing="0">
    <thead>
      <tr className={S.headerRow}>
        <th className={S.column}>Store #</th>
        <th className={S.column}>Install Date</th>
        <th className={S.column}>Installer</th>
        <th className={S.column}>Appointment Type</th>
        <th className={S.column}>Customer Name</th>
        <th className={S.column}>PO #</th>
        <th className={S.column}>Carpet</th>
        <th className={S.column}>Bin</th>
        <th className={S.column}>Tag #</th>
        <th className={S.column}>Pad Type</th>
        <th className={S.column}>Pad QTY</th>
        <th className={S.column}>Cut</th>
        <th className={S.column}>Release</th>
      </tr>
    </thead>
    <tbody>
      {data.map(appt =>
        <tr key={appt.id} className={S.contentRow}>
          <td className={S.column}>
            <Link to={urls.store(appt.store)} className={reportStyle.link} target="_blank">
              {appt.store.number}
            </Link>
          </td>
          <td className={S.column}>
            <div>{moment(appt.start_date).format('MM/DD/YYYY')}</div>
            {formatTime(appt.arrival_start_time)} - {formatTime(appt.arrival_end_time)}
          </td>
          <td className={S.column}>{appt.assignee.name}</td>
          <td className={S.column}>{capitalize(appt.kind)}</td>
          <td className={S.column}>
            <Link to={urls.phaseWarehouseMaterials(appt.phase.id)} className={reportStyle.link} target="_blank">
              {appt.phase.customer_name}
            </Link>
          </td>
          <td className={S.column}>
            {appt.phase.original_po}
          </td>
          <td className={S.column}>
            {uniqueValues(appt.warehouse_merchandise_items, 'item_name')}
          </td>
          <td className={S.column}>
            {uniqueValues(appt.warehouse_merchandise_items, 'bin')}
          </td>
          <td className={S.column}>
            {uniqueValues(appt.warehouse_merchandise_items, 'tag_number')}
          </td>
          <td className={S.column}>
            {uniqueValues(appt.phase_line_items, 'description')}
          </td>
          <td className={S.column}>
            {appt.phase_line_items.map(i => cutQuantityString(i.warehouse_quantity)).join(', ')}
          </td>
          <td className={S.column}>
            {appt.phase_line_items.map(i => i.warehouse_status).join(', ')}
          </td>
          <td className={`${S.column} ${S.centeredColumn}`}>
            <ReleaseMerchandise appt={appt} />
          </td>
        </tr>,
      )}
      {!data.length && <tr>
        <td colSpan="9" className={`${reportStyle.empty} ${S.column}`}>No Matching Appointments</td>
      </tr>}
    </tbody>
  </table>;

WarehouseSummaryTable.propTypes = {
  report: PropTypes.shape({
    loading: PropTypes.bool,
    loaded: PropTypes.bool,
    data: PropTypes.array,
  }),
};

export default connect(state => ({
  report: state.reports.warehouse,
}))(WarehouseSummaryTable);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/reports/warehouse/components/WarehouseSummaryTable/index.jsx